module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Gd-Ha-Ia.b3b32cec.png";